//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwoopForm from '@/components/SwoopForm'
import { USER_MASQUERADE_REQUEST } from '@/store/modules/user/actions'
import * as Sentry from '@sentry/browser'
import API from '@/api/apiHelper'

export default {
  name: 'Masquerade',
  components: { SwoopForm },
  data() {
    return {
      form: null,
      performingMasquerade: false,
      masquerade: {
        currentUser: this.$store.getters.getUserFullName,
        newUser: ''
      }
    }
  },

  computed: {
    fields() {
      return [
        {
          id: 'currentUser',
          type: 'name',
          label: 'Current user',
          disabled: true
        },
        {
          id: 'newUser',
          label: 'Masquerade as',
          type: 'autocomplete',
          getOptions: this.getUserOptions,
          required: true
        }
      ]
    }
  },

  methods: {
    async getUserOptions(value, done) {
      let autocompleteOptions = []
      if (typeof value !== 'undefined' && value.length >= 3) {
        let searchResults = await API.query(
          `
          query Query($search: String) {
            userSearch(search: $search, includeAdmins: false) {
              data {
                id
                full_name
                email
                account {
                  name
                }
              }
            }
          }
        `,
          {
            search: value
          },
          {
            spinner: false
          }
        )

        autocompleteOptions =
          searchResults?.data.map(value => {
            return {
              value: value.id,
              label:
                value.full_name +
                ' [' +
                value.email +
                '] - ' +
                value.account.name
            }
          }) || []
      }

      return done(autocompleteOptions)
    },
    performMasquerade() {
      this.performingMasquerade = true
      this.$store
        .dispatch(USER_MASQUERADE_REQUEST, {
          user_id: this.masquerade.newUser
        })
        .then(() => {
          // this chunk of code is to "refresh" the current page, will force the navigation guards to rerun,
          // this is to stop someone masquerading to something that shouldn't have access to
          const to = this.$router.currentRoute
          this.$router.replace('/')
          this.$router.replace(to)
          this.performingMasquerade = false
          this.$emit('close')
        })
        .catch(error => {
          Sentry.captureException(error)
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.performingMasquerade = false
        })
    }
  }
}
